import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  academylist,
  leavecountdashboard,
  leavelist,
} from "../../../services/admin";
export default function Leavedashboard() {
  const [filterProduct, setFilterProduct] = useState([]);
  const [fromdate, setFromDate] = useState("");
  const [todate, setToDate] = useState("");
  const columnDefs = [
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: (params) => {
        if (params.value === "Approved") {
          return { color: "green", fontWeight: "bold" };
        } else if (params.value === "Rejected") {
          return { color: "red", fontWeight: "bold" };
        } else if (params.value === "Pending") {
          return { color: "blue", fontWeight: "bold" };
        } else {
          return { color: "brown", fontWeight: "bold" };
        }
      },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Leave",
      field: "leave_permission",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "leave_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Days/Hours",
      field: "total_leave",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "From Date",
      field: "from_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
    {
      headerName: "To Date",
      field: "to_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
    {
      headerName: "Reason",
      field: "reason",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    const currentDate = new Date();
    const firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    listall(
      moment(firstDay).format("YYYY-MM-DD"),
      moment(new Date()).format("YYYY-MM-DD")
    );

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listcount(arr[0]);
                
              }
            }
           
          }
        }
      });
    }else{
      listcount("");
    }

  }, []);

  function listall(fdate, tdate) {
    setFilterProduct([]);
    setFromDate(fdate);
    setToDate(tdate);
    const temp = new FormData();
    temp.append("from_date", fdate);
    temp.append("to_date", tdate);
    if(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "5") {
      temp.append("user_id", localStorage.getItem("UID"));
    }
    leavelist(temp).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
  }
  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listcount(e);
    } else {
      setAcaID("");
      listcount("");
    }
  }
  const [lcount, setLCount] = useState("");
  const [pcount, setPCount] = useState("");
  function listcount(acid) {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && acid !== "") {
      temp.append("academy_id", acid.value);
    }
    if(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "5") {
      temp.append("user_id", localStorage.getItem("UID"));
    }
    leavecountdashboard(temp).then((res) => {
      if (res.status === true) {
        setLCount(res.data.leave_counts);
        setPCount(res.data.permission_counts);
      }
    });
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Leave Dashboard</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Leave Management</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Leave Dashboard
          </li>
        </ol>
      </div>
      {localStorage.getItem("Role") === "1" && (
        <div className="col-xl-4 col-sm-6">
          <div className="mb-3">
            <label className="form-label">
              Select Academy <span className="text-danger"> *</span>
            </label>
            <Select
              className="default-select"
              placeholder="Select Academy"
              value={acaid}
              options={aclist}
              onChange={handleAcademy}
              isSearchable={true}
              isClearable
              hidden
            />
          </div>
        </div>
      )}

      <div className="row row-sm">

        <div className="col-xl-3 col-md-4">
          <div className="card custom-card">
            <div className="card-bodyy I-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Sick Leave</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{lcount ? lcount.sick.approved : 0}</a> <p className="text-muted ">Approved</p>
                </h3>
              </div>
              <div className="col-md-6 col text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{lcount ? lcount.sick.rejected : 0}</a> <p className="text-muted ">Rejected</p>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-4">
          <div className="card custom-card">
            <div className="card-bodyy II-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Casual Leave</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{lcount ? lcount.casual.approved : 0}</a> <p className="text-muted ">Approved</p>
                </h3>
              </div>
              <div className="col-md-6 col text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{lcount ? lcount.casual.rejected : 0}</a> <p className="text-muted ">Rejected</p>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-4">
          <div className="card custom-card">
            <div className="card-bodyy III-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Personal Leave</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{lcount ? lcount.personal.approved : 0}</a> <p className="text-muted ">Approved</p>
                </h3>
              </div>
              <div className="col-md-6 col text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{lcount ? lcount.personal.rejected : 0}</a> <p className="text-muted ">Rejected</p>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-4">
          <div className="card custom-card">
            <div className="card-bodyy VII-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Permission</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{pcount ? pcount.approved : "0"}</a> <p className="text-muted ">Approved</p>
                </h3>
              </div>
              <div className="col-md-6 col text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{pcount ? pcount.rejected : "0"}</a> <p className="text-muted ">Rejected</p>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="card-header">
                <div>
                <h2 className="main-content-title tx-24 mg-b-5">
                    {" "}
                    Current Month Total Leaves
                  </h2>{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-3">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromdate}
                    onChange={(e) => listall(e.target.value, todate)}
                  />
                </div>
                <div className="col-lg-3 col-md-3">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={todate}
                    onChange={(e) => listall(fromdate, e.target.value)}
                  />
                </div>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
